import {
  Component,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
} from '@angular/core';
import { take } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { Message, MessageUpdate } from '@cigna/chcp/shared/util';
import { MessageDeleteDialogComponent } from '@cigna/chcp/shared/ui';

@Component({
  selector: 'cigna-message-tile-widget',
  templateUrl: './message-tile-widget.component.html',
  styleUrls: ['./message-tile-widget.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MessageTileWidgetComponent {
  @Input() message: Message;
  @Input() isImpersonator: boolean;

  @Output() updateMessages: EventEmitter<MessageUpdate> = new EventEmitter();
  @Output() deleteMessages: EventEmitter<string[]> = new EventEmitter();

  isCollapsed = true;

  constructor(public dialog: MatDialog) {}

  toggle() {
    this.isCollapsed = !this.isCollapsed;
  }

  openDeleteDialog() {
    this.dialog
      .open(MessageDeleteDialogComponent)
      .afterClosed()
      .pipe(take(1))
      .subscribe((output) => {
        if (output?.canDelete && this.message?.id) {
          this.deleteMessages.emit([this.message.id]);
        }
      });
  }
}
